import XCWebSocket, {EventsNames} from '@x-tech/fe-lib-webscoket';
import Vue from 'vue';
import store from '@/store/store';
import { SET_WS_EXPORT_NUMBER,SET_WS_EXPORT_INFO } from '@/store/mutation-types';
import { Notification as elNotification } from 'element-ui';
import router from '../router/router';
import VueCookies from 'vue-cookie';
import { consts as pumaConsts } from '@x-tech/fe-puma-lib';

const prefix = '_XCWS';
let count = 0;
let exportList = [];

function getToken() {
    const cookie = VueCookies.get(pumaConsts.TOKEN_COOKIE_NAME);

    if (cookie) {
        let accessToken;

        try {
            accessToken = JSON.parse(cookie).accessToken;
        } catch (e) {
            console.warn(`cookie 值非法: ${cookie}`);
            VueCookies.delete(pumaConsts.TOKEN_COOKIE_NAME);
            return;
        }

        return accessToken;
    }
}

function getUser(){
    let username = store.state.user.username;
    return username;

}
function handleExportEvent(msg) {

    if (msg.messageEvent==='DOWNLOAD_EVENT') {
        let countNum = ++count;
        store.commit(SET_WS_EXPORT_NUMBER, countNum);
        exportList.push(msg);
        store.commit(SET_WS_EXPORT_INFO, exportList);
        elNotification({
            type: 'info',
            title: '新提示',
            message: `${msg.messageBody}，点击本消息进入页面~`,
            onClick: async() => {
                Vue.prototype.$ws.send({'username': msg.username,'messageEvent': msg.messageEvent,'productCode': msg.productCode});
                let countNum = --count;
                store.commit(SET_WS_EXPORT_NUMBER, countNum);
                let list = exportList.filter(item => item.messageBody !== msg.messageBody);
                store.commit(SET_WS_EXPORT_INFO, list);
                await router.push(`/container/${msg.productCode}${msg.pageUrl}`);
                window.location.reload();
            }
        });
    }
}

// 消息类型 处理方法集合，所有的消息处理函数都应该在此处处理
// 特殊的需要在业务页面内处理的
const eventFnMap = {
    'DOWNLOAD_EVENT': handleExportEvent,

};

export function $_initWs(url = window.XCConfig.VUE_APP_WS_URL, config = {
    heartMsg: {'messageEvent': 'HEART_EVENT','username': getUser()},
    heartDelay: 30 * 1000
}) {
    // return;
    // 如果是第一次登陆，应该初始化 $ws 对象，
    // 否则需要检查 是否需要自动登录，不需要的话直接 return

    // 获取 token， 没有token 就不连接
    // let test = {
    //     messageBody: '下载任务:kkkkjgu.xlsx,已完成',
    //     messageEvent: 'DOWNLOAD_EVENT',
    //     pageUrl: '/downloadCenter/list',
    //     productCode: 'account',
    //     username: 'XC09932'
    // };
    // handleExportEvent(test);
    let token = getToken();
    if (!token) {
        return;
    }
    // 连接 ws
    let $ws = new XCWebSocket(`${url}/${token}` , config);

    $ws.on(EventsNames.message, (msg) => {
        const EventName = msg.data.messageEvent;
        eventFnMap[EventName] ? eventFnMap[EventName](msg.data) : '';
    });
    Vue.prototype.$ws = $ws;
}

export function $_destoryWs() {
    sessionStorage.removeItem(`${prefix}_auto_connection`);
    // todo destory ws;
    Vue.prototype.$ws.destory();
    Vue.prototype.$ws = undefined;
}
